import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import './Completed.css';

const Completed = ({ count = 0 }) => {
    return (
        <div className="completed-card">
            <div className="completed-header">
                <span className="completed-title">Completed</span>
                <FontAwesomeIcon icon={faCheckCircle} className="completed-icon" />
            </div>
            <span className="completed-count">{count}</span>
        </div>
    );
};

export default Completed;
